import { render, staticRenderFns } from "./GiveAndAskCategoriesPost.vue?vue&type=template&id=4a8b0e46&"
import script from "./GiveAndAskCategoriesPost.vue?vue&type=script&lang=js&"
export * from "./GiveAndAskCategoriesPost.vue?vue&type=script&lang=js&"
import style0 from "./GiveAndAskCategoriesPost.vue?vue&type=style&index=0&id=4a8b0e46&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports